// extracted by mini-css-extract-plugin
export default {"container":"Header_container__zmwVK","loginBtn":"Header_loginBtn__Ptcc7","heading":"Header_heading__O065u","navlinks":"Header_navlinks__HqrVu"};